import Tiptap from './Tiptap'
import { withTiptap } from './withTiptap'

const ConnectedTiptap = withTiptap(Tiptap)

export { ConnectedTiptap as Tiptap }
